import { API } from 'aws-amplify';
import { calculateVitalsAbnormalities } from '../../common/graphql/queries';

export const callCalculateVitalsAbnormalities = async (input: any): Promise<string> => {
    try {
        const response: any = await API.graphql({
            query: calculateVitalsAbnormalities,
            variables: {
                input: JSON.stringify(input),
            }
        });
        console.log('callCalculateVitalsAbnormalities response', JSON.parse(response["data"]["calculateVitalsAbnormalities"]));
        return response["data"]["calculateVitalsAbnormalities"];
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callCalculateVitalsAbnormalities");
        return "";
    }
}
